<template>
  <div class="company_module module_item">
    <div class="search">
      <!-- <el-select
        v-model="TranscationData.country"
        placeholder="Country"
        class="module_search_select"
        @change="emitSearch"
      >
        <el-option
          v-for="item in countryList"
          :key="item.name"
          :label="item.name"
          :value="item.name"
        ></el-option>
      </el-select>-->
      <el-cascader
        :options="v2CountryList"
        :props="propsNew"
        v-model="TranscationData.country"
        @change="emitSearch"
        ref="cInput"
        placeholder="Country"
        class="module_search_select"
      ></el-cascader>
      <!--  -->
      <el-select
        v-model="TranscationData.dealStatus"
        placeholder="All Status"
        class="module_search_select"
        @change="emitSearch"
      >
        <el-option
          v-for="item in options2"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <!--  -->
      <el-select
        v-model="TranscationData.dealType"
        placeholder="All Type"
        class="module_search_select"
        @change="emitSearch"
      >
        <el-option
          v-for="item in options3"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>

    <div class="list_resullt" v-if="lists.length">
      <div class="result_item result_item_transcation" v-for="(item,index) of lists" :key="index" @click="searchData(item)">
        <div class="item_title">
          <span class="title columnText2" :title="item.deal_headline">{{item.deal_headline}}</span>
          <!-- <slot name="tag" :item="item"></slot> -->
        </div>
        <div class="detail">
          <p v-for="(list,j) of detailLists" :key="j" class="detail_item">
            <span class="tag_label">{{list.label}}:&nbsp &nbsp</span>
            <span class="tab_value" v-if="typeof item[list.key]=='string'">{{item[list.key]}}</span>
            <span v-else class="tab_value valueArr">
              <p v-for="(keyItem,keyIndex) of item[list.key]" :key="keyIndex">{{keyItem}}</p>
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="list_resullt" v-else>
      <div class="noData no_data_container">
        <span class="img no_data_img"></span>
        <p>Sorry, No data was found</p>
      </div>
    </div>

    <div class="page_footer clearfix">
      <p class="total_page">Total {{total}} records</p>
      <el-pagination :total="total" layout="prev, next" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import debounceMixin from "common/js/mixin/debounce";
import { getNation, getCountryList } from "common/js/http/v2Api";
import { mapState } from "vuex";

const options2 = [
  {
    value: "Announced",
    label: "Announced"
  },
  {
    value: "Completed",
    label: "Completed"
  },
  {
    value: "Pending",
    label: "Pending"
  },
  {
    value: "Postponed",
    label: "Postponed"
  },
  {
    value: "Rumour",
    label: "Rumour"
  },
  {
    value: "Unconditional",
    label: "Unconditional"
  },
  {
    value: "Withdraw",
    label: "Withdraw"
  }
];

const options3 = [
  {
    value: "Acquisition",
    label: "Acquisition"
  },
  {
    value: "IPO",
    label: "IPO"
  },
  {
    value: "Planned IPO",
    label: "Planned IPO"
  },
  {
    value: "Institutional buy-out",
    label: "Institutional buy-out"
  },
  {
    value: "Capital increase",
    label: "Capital increase"
  },
  {
    value: "Joint-venture",
    label: "Joint-venture"
  },
  {
    value: "MBI/MBO",
    label: "MBI/MBO"
  },
  {
    value: "Management buy-in",
    label: "Management buy-in"
  }
];

const detailLists = [
  {
    label: "Target",
    key: "target" //后台字段
  },
  {
    label: "Acquiror",
    key: "acquiror" //后台字段
  },
  {
    label: "Vendor",
    key: "vendor" //后台字段
  }
];

export default {
  props: ["lists", "total"],

  mixins: [debounceMixin],

  data() {
    return {
      propsNew: {
        label: "enName",
        value: "enName"
      },

      countryList: [],

      options2,
      options3,

      TranscationData: {
        country: "",
        dealStatus: "",
        dealType: "",
        page: 1,
        size: 10
      },

      detailLists //每个模块的字段不同
    };
  },

  created() {
    this.emitSearch();
    this.getCountry();
  },

  methods: {
    async getCountry() {
      const { result } = await getCountryList();
      this.countryList = result;
    },

    emitSearch() {
      let data = this.$lodash.cloneDeep(this.TranscationData);
      // 级联菜单获取的是数组  取最后一项
      let countryData;
      if (data.country.length > 0) {
        countryData = data.country[data.country.length - 1];
      } else countryData = "";
      data = Object.assign(data, { country: countryData });
      this.$emit("search", "transcation", data);
    },

    searchData(item) {
      // this.setLeftCollapse();
      // this.$router.push({
      //   path: "/data/SearchModule/Transaction",
      //   query: {
      //     id: item.fid
      //   }
      // });
      this.changRightStatus(item.fid);
    },

    handleCurrentChange(val) {
      this.TranscationData.page = val;
      this.emitSearch();
    },

    changRightStatus(id) {
      this.$emit("changRightStatus", "Transaction", id);
    }
  },
  computed: {
    ...mapState({
      v2CountryList(state) {
        return state.v2Permission.v2CountryList;
      }
    })
  }
};
</script>

<style scoped>
.list_resullt {
  margin-top: 10px;
  height: calc(100% - 160px);
  overflow-y: auto;
  padding: 0px 10px 0px 0px;
}

.page_footer >>> .el-pagination {
  float: right;
}

.total_page {
  float: left;
  height: 32px;
  line-height: 32px;
}

.page_footer {
  border-top: 1px solid #dee2e6;
  padding-top: 16px;
}

.tag_label {
  display: inline-block;
  width: 80px;
}

.tab_value {
  display: inline-block;
  width: calc(100% - 80px);
  vertical-align: top;
}
</style>